import React from 'react';
import { useField } from 'formik';

import { Checkbox, FormControlLabel, FormHelperText } from '@material-ui/core';

interface Props {
    label?: string | React.ReactNode,
    labelProps?: {
        className?: string,
    },
    name: string,
    fullWidth?: boolean,
}

const FormikCheckbox = ({
  label, labelProps, name, ...checkboxProps
}: Props) => {
  // useField() returns [formik.getFieldProps(), formik.getFieldMeta()]
  // which we can spread on <input> and also replace ErrorMessage entirely.
  const [field, meta] = useField({ name });
  return (
    <>
      <FormControlLabel
        control={(
          <Checkbox
            {...checkboxProps}
            {...field}
            checked={field.value}
          />
        )}
        label={label}
        {...labelProps}
      />
      <FormHelperText error>
        {meta.touched && meta.error}
      </FormHelperText>
    </>
  );
};

export default FormikCheckbox;
